// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// DEPRECATED: please see ScrollBorder
// We can add support for shadow over border there - but it does not use scroll events
// and i do not have the time atm to track down the few components that may be using this
// (ORIGINAL) TODO: This is not the best - it tries to do too much
// the scroll added nodes into view should be handled elsewhere
// I wrote this before I fully understood how to combine refs
import React, {useCallback, useReducer, useRef} from 'react';
import clsx from 'clsx';
import ResizeDetector from 'react-resize-detector';
import _ from 'underscore';
import {createStyles, withStyles, type WithStyles} from '@mui/styles';
import type {Theme} from '@netx/core-components/Theme';
import {combineRefs} from '@netx/core-next/utils/react';
import useScrollAddedNodesIntoView from './useScrollAddedNodesIntoView';
import useScrollListener from './useScrollListener';

const shadow = [
	'radial-gradient(farthest-side at 50% 0px, rgba(0,0,0,.2), rgba(0,0,0,0))', // Top
	'radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0)) 0 100%', // Bottom
];
const shadowSize = ['100% 6px', '100% 14px'];
const createShadow = (side: 'top' | 'bottom' | 'all') => {
	const styles = {
		backgroundRepeat: 'no-repeat',
	};
	switch (side) {
		case 'top':
			return {
				...styles,
				background: shadow[0],
				backgroundSize: shadowSize.join(),
			};
		case 'bottom':
			return {
				...styles,
				background: shadow[1],
				backgroundSize: shadowSize.join(),
			};
		case 'all':
			return {
				...styles,
				background: shadow.join(),
				backgroundSize: `${shadowSize[0]}, ${shadowSize[0]}, ${shadowSize[1]}, ${shadowSize[1]}`,
			};
	}
};

const styles = (theme: Theme) =>
	createStyles({
		overflown: {
			'&:not($scrolled)': createShadow('bottom'),
			'&$scrollEnd': createShadow('top'),
			'&$scrolled:not($scrollEnd)': createShadow('all'),
		},
		scrolled: {},
		scrollEnd: {},
	});

export interface ScrollShadowWrapperProps {
	className?: string;
	scrollNewItemsIntoView?: boolean;
}

export interface ScrollShadowWrapperChildProps {
	className: string;
	ref:
		| ((instance: HTMLDivElement | null) => void)
		| React.RefObject<HTMLDivElement>
		| null;
}

const initialState = {
	clientHeight: 0,
	isOverflown: false,
	isScrolled: false,
	reachedScrollEnd: false,
};

const reducer = (state = initialState, action: any): typeof initialState => {
	switch (action.type) {
		case 'RESIZE': {
			const {clientHeight, scrollHeight, scrollTop} = action.data;
			return {
				...state,
				clientHeight,
				isOverflown: clientHeight < scrollHeight,
				isScrolled: scrollTop > 0,
				reachedScrollEnd: scrollTop === scrollHeight - clientHeight,
			};
		}
		case 'SCROLL': {
			const {scrollHeight, scrollTop} = action.data;
			return {
				...state,
				isScrolled: scrollTop > 0,
				reachedScrollEnd: scrollTop === scrollHeight - state.clientHeight,
			};
		}
		default:
			return state;
	}
};

// TODO: this only works for vertical scrolling ATM
/**
 * Provide some auto-scroll/shadow functionality to your list components
 *
 * This will only look for nodes added as direct descendants so be sure
 * to apply this to the last level of your list
 *
 * The component being wrapped must utilize `React.forwardRef`
 * @deprecated
 * @example
 * const ListWrapper = ScrollShadowWrapper(
 *     React.forwardRef((props, ref) => {
 *         return <div {...props} ref={ref} />;
 *     })
 * );
 * <ListWrapper>...list items</ListWrapper>
 */
const ScrollShadowWrapper = (
	Component: React.ForwardRefExoticComponent<ScrollShadowWrapperChildProps>,
) => {
	return withStyles(styles)(
		React.memo(
			({
				classes,
				className,
				scrollNewItemsIntoView = false,
				...props
			}: WithStyles<typeof styles> & ScrollShadowWrapperProps) => {
				const [state, dispatch] = useReducer(reducer, initialState);

				const ref = useRef<HTMLDivElement>(null);

				useScrollAddedNodesIntoView({
					enabled: scrollNewItemsIntoView,
					ref,
				});

				useScrollListener({
					ref,
					onScroll: useCallback(
						(container) => {
							dispatch({
								type: 'SCROLL',
								data: {
									scrollHeight: container.scrollHeight,
									scrollTop: container.scrollTop,
								},
							});
						},
						[dispatch],
					),
				});

				const handleResize = useCallback(() => {
					if (!ref.current) return;
					const {scrollTop, scrollHeight, clientHeight} = ref.current;
					dispatch({
						type: 'RESIZE',
						data: {
							clientHeight,
							scrollHeight,
							scrollTop,
						},
					});
				}, []);

				return (
					<ResizeDetector<HTMLDivElement> handleHeight onResize={handleResize}>
						{({targetRef}) => (
							<Component
								{...props}
								className={clsx(className, {
									[classes.overflown]: state.isOverflown,
									[classes.scrolled]: state.isScrolled,
									[classes.scrollEnd]: state.reachedScrollEnd,
								})}
								ref={combineRefs(targetRef, ref) as any}
							/>
						)}
					</ResizeDetector>
				);
			},
		),
	);
};

export default ScrollShadowWrapper;
